import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, computedFrom } from 'aurelia-framework';
import { GlobalContextService } from '../../components/global-select/global-context-service';
import { IScopeAM } from '../scopes/scope-service';

@autoinject
export class FinancialEntriesContainer {
	customerId: string;
	fiscalYearId: string;
	scopeId: string;
	organizationId: string;

	scope: IScopeAM;

	private customerItemName = 'customer';
	private scopeItemName = 'scope';

	constructor(
		private globalContext: GlobalContextService,
		private eventAggregator: EventAggregator) {

		this.customerId = this.globalContext.getId(this.customerItemName);
		const scope = this.globalContext.getItem(this.scopeItemName);
		this.setScopeProperties(scope);

		this.eventAggregator.subscribe(`idChanged-${this.customerItemName}`, id => {
			this.customerId = id;
		});

		this.eventAggregator.subscribe(`itemChanged-${this.scopeItemName}`, item => {
			this.setScopeProperties(item);
		});
	}

	private setScopeProperties(scope: IScopeAM) {
		this.scope = scope;

		this.scopeId = scope != null ? scope.id : null;
		this.organizationId = scope != null ? scope.organizationId : null;
		this.fiscalYearId = scope != null ? scope.fiscalYearId : null;
	}

	@computedFrom('scopeId')
	get scopeSelected() {
		return this.scopeId !== '' && this.scopeId != null;
	}

	@computedFrom('scope')
	get scopeName(): string {
		if (this.scope) {
			return `${this.scope.name} ${this.scope.specifier ? this.scope.specifier : ''}`;
		}

		return null;
	}
}
